const CancelCallTransferSearchInitialValues = {
  callerId: '',
};

export default CancelCallTransferSearchInitialValues;

export type CancelCallTransferSearchFormBody = typeof CancelCallTransferSearchInitialValues;
